import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ReportsService } from '../../../../services/reports.service';
import { saveAs } from 'file-saver';
import { RouterModule } from '@angular/router';
import { CommonService } from '../../../../services/common.service';


@Component({
    selector: 'app-missing-permanent-repair-date-report',
    imports: [TableModule, CommonModule, FormsModule, RouterModule],
    templateUrl: './missing-permanent-repair-date-report.component.html',
    styleUrl: './missing-permanent-repair-date-report.component.scss'
})
export class MissingPermanentRepairDateReportComponent {

  missingPermanentRepairDate: any;
  isLoading: boolean = false;

  ngOnInit() {
    this.getMissingPermanentRepairDate('ES', this.commonService.getUserCai());
  }
  constructor(private report: ReportsService,
    public commonService: CommonService
  ) { }


  getMissingPermanentRepairDate(facilityId: string, userCAI: string): void {
    this.isLoading = true;
    this.report.getMissingPermanentRepairDate(facilityId, userCAI).subscribe(
      (data: any) => {
        this.missingPermanentRepairDate = data;
        this.isLoading = false;
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error fetching air compliance details', error);
      }
    );
  }

  exportToExcel() {
    let params = {
      facilityID: localStorage.getItem('current_facility_id'),
      userCAI: this.commonService.getUserCai(),
    }
    this.report.getMissingPermanentRepairDateExcel(params)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, 'Missing Permanent Repair Date.xlsx');
          }

        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      })
  }
}
